import React, { useEffect, useState } from "react";
import Container from "../../components/container/Container";
import Checkbox from "../../components/checkbox/Checkbox";
import Button from "../../components/button/Button";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { submitFormData } from "../../api/permission";
import { getPlantConfig } from "../../api/config";
import ExternalLink from "../../components/link/ExternalLink";
import { ROUTE_PATH } from "../../contants/routePath";
import Loader from "../../components/loader/Loader";
import { Alert, Snackbar } from "@mui/material";

const Permissions = () => {
  const [formState, setFormState] = useState({ lgv: false });
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const { data: result, isLoading } = useQuery({
    queryKey: [id],
    queryFn: () => {
      return getPlantConfig(id);
    },
    onSuccess: (data) => {
      setFormState((prev) => {
        return { lgv: data.plantConfig.indoorMap.lgvs.isEnabled };
      });
    },

    staleTime: Infinity,
  });

  const {
    isSuccess,
    isError,
    mutateAsync: formMutuation,
  } = useMutation({
    mutationFn: (formData: any) => {
      return submitFormData(formData);
    },
    onSettled: () => {
      setOpen(true);
    },
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState((prev) => {
      return { ...prev, [e.target.name]: e.target.checked };
    });
  };

  const handleSaveAndPublish = async () => {
    result.enabled = 1;
    result.plantConfig.indoorMap.lgvs.isEnabled = formState.lgv;
    formMutuation({
      code: id,
      body: result,
    });
  };

  const handleSaveAsDraft = async () => {
    result.enabled = 0;
    result.plantConfig.indoorMap.lgvs.isEnabled = formState.lgv;
    formMutuation({
      code: id,
      body: result,
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      {
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          autoHideDuration={3000}
          onClose={() => setOpen(false)}
        >
          {isSuccess ? (
            <Alert variant="filled" severity="success">
              Saved Successfully
            </Alert>
          ) : (
            <Alert variant="filled" severity="error">
              An Error Occured
            </Alert>
          )}
        </Snackbar>
      }

      <div className="relative h-full">
        <h3 className="text-secondaryText font-medium">
          Please select the options you want to display on the LGV One portal
        </h3>
        <div>
          {/* <Checkbox label="Real-Time Warehouse Indoor Map" id="All" /> */}
          <div className="ml-8">
            <Checkbox
              checked={formState["lgv"]}
              label="LGVs"
              id="lgv"
              name="lgv"
              onChange={(e) => handleChange(e)}
            />
            {/* <Checkbox label="Dock Doors" id="dock_door" />
          <Checkbox label="Production Line" id="production_line" />
          <Checkbox label="Block Storage" id="block_storage" />
          <Checkbox label="Rack Storage" id="rack_stroage" />
          <Checkbox label="Destination Pointers" id="destination_pointers" />
          <Checkbox label="Non-LGV Inventory" id="non_lgv_inventory" />
          <Checkbox label="Heat Map" id="heatmap" /> */}
          </div>
        </div>
        <div className=" flex justify-end gap-5 items-end absolute bottom-2 w-full">
          <ExternalLink
            href={`${ROUTE_PATH.lgv}/${id}/preview`}
            target="_blank"
          >
            Preview
          </ExternalLink>
          <Button onClick={handleSaveAsDraft}>Save as Draft</Button>
          <Button onClick={handleSaveAndPublish}>Save & Publish</Button>
        </div>
      </div>
    </Container>
  );
};

export default Permissions;
